// extracted by mini-css-extract-plugin
export default {"dropdown":"ClassTag_dropdown__dpJZ+","rootColor":"ClassTag_rootColor__WCSRV"};